// removed by extract-text-webpack-plugin
module.exports = {"navbarWrapper":"_1IU3_navbarWrapper","navbarMainMenu":"_2E6I_navbarMainMenu","isActive":"_2bvI_isActive","mainMenuItem":"_2vAH_mainMenuItem","ActiveArrow":"_3MfQ_ActiveArrow","MenuItemIcon":"_3zWO_MenuItemIcon","menuTrigger":"_3hHL_menuTrigger","MenuIcon":"te08_MenuIcon","isWhite":"_3sp4_isWhite"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navbar/Navbar.module.scss
// module id = 448
// module chunks = 42